// extracted by mini-css-extract-plugin
export default {"button":"MemoryChatButtons_button-iZH","iconAppear":"MemoryChatButtons_iconAppear-_ZG","listening":"MemoryChatButtons_listening-oeB","pulse":"MemoryChatButtons_pulse-Paa"};